import React from 'react';
import { useParams } from 'react-router-dom';
import approvalApi from '../apis/approvalsApi';
// import { connect } from 'react-redux';
// import MediaQuery from 'react-responsive';
// import { selectSystem } from '../actions';
//import HeaderFilterBs from './HeaderFilterBs';


const StatsRedirect = () => {
    const { user, app } = useParams();

    console.log("Redirecting user to: ", app);
    let url = "https://intuitive.com";

    //switch to determine where to URL based on paraams
    switch (app) {
        case "isu":
            url = process.env.REACT_APP_ISU_PROD_LINK
            break;
        case "helpnow":
            url = process.env.REACT_APP_HELPNOW_PROD_LINK
            break;
        case "sam":
            url = process.env.REACT_APP_SAM_PROD_LINK
            break;
        case "agile":
            url = process.env.REACT_APP_AGILE_PROD_LINK
            break;
        case "coupa":
            url = process.env.REACT_APP_COUPA_PROD_LINK
            break;
        case "ivalua":
            url = process.env.REACT_APP_IVALUA_PROD_LINK
            break;
        case "sapqn":
            url = process.env.REACT_APP_SAPQN_PROD_LINK
            break;
        case "trackwise":
            url = process.env.REACT_APP_TRACKWISE_PROD_LINK
            break;
        case "rce":
            url = process.env.REACT_APP_RCE_PROD_LINK
            break;
        case "ittimesheet":
            url = process.env.REACT_APP_ITTIMESHEET_PROD_LINK
            break;
        case "concur":
            url = process.env.REACT_APP_CONCUR_PROD_LINK
            break;
        case "neptunemt":
            url = process.env.REACT_APP_NEPTUNEMT_PROD_LINK
            break;
        case "fieldglass":
            url = process.env.REACT_APP_FIELDGLASS_PROD_LINK
            break;
        case "SMARTRECRUITERS":
            url = process.env.REACT_APP_SMARTRECRUITERS_PROD_LINK
            break;
        case "neptuneps":
            url = process.env.REACT_APP_NEPTUNEPS_PROD_LINK
            break;
        case "myhcm":
            url = process.env.REACT_APP_MYHCM_PROD_LINK
            //url = 'https://intusurg.okta.com/home/intuitivesurgical_oraclehcm_1/0oa1dz9bryiTBtpMN1d8/aln1dz9evhjhoMPSd1d8'
            break;
        case "mes":
            url = process.env.REACT_APP_MES_PROD_LINK
            break;
        case "adobesign":
            url = process.env.REACT_APP_ADOBESIGN_PROD_LINK
            break;
        case "archibus":
            url = process.env.REACT_APP_ARCHIBUS_PROD_LINK
            break;
        case "purchaseorder":
            url = process.env.REACT_APP_PO_PROD_LINK
            break;
        case "workday":
            url = process.env.REACT_APP_WORKDAY_PROD_LINK
            break;
        case "workforce":
            url = process.env.REACT_APP_WORKFORCE_PROD_LINK
            break;
        case "sapchange":
            url = process.env.REACT_APP_SAP_CHANGE_PROD_LINK
            break;
        case "archibusmaintenance":
            url = process.env.REACT_APP_ARCHIBUS_MAINTENANCE_PROD_LINK
            break;
        case "smartsimple":
            url = process.env.REACT_APP_SMARTSIMPLE_PROD_LINK
            break;
        default:
            url = process.env.REACT_APP_DEFAULT_PROD_LINK
            break;
    }

    //example: http://localhost:3000/redirect/beto.hernandezadame/myhcm
    //Go to Target App
    window.location.replace(url);

    // localhost:3000/redirect/beto.hernandezadame/isu

    const body = {
        source: "zoombot",
        app: app,
        uid: user,
        refKey: "e62778492de242a4b66ec230c24baeee"
    };
    try {
        const response = approvalApi.post("/UserAppStats/update", body);
        //console.log("SUCCESS sending Stats: ", response.data);
    } catch (err) {
        console.log("Calling Stats API error. ", err);
    }
    return (
        <>Will redirect to {app} in 3 seconds...</>
    );
};

export default StatsRedirect;
